Cm.map = {
    loading: function($el) {
		$el.html(
			'<div class="map-inside-loader d-flex justify-content-center align-items-center align-self-center">'+
				'<img style="" src="' + (wp.location_map_loader || 'https://s3-eu-west-2.amazonaws.com/staycom-wordpress/wp-content/uploads/2019/05/03125753/img-loader.gif')  +'" />'+
			'</div>'
		);
	},
    init: function() {
        var $maps = $('[data-plugin="map"]');
        var scripts = {
            'leaflet': wp.asset_path + "/plugins/leaflet/leaflet.js",
            'esri': wp.asset_path + "/plugins/leaflet/esri-leaflet.js",
            'mapbox': wp.asset_path + "/plugins/leaflet/mapbox-gl.js",
            'vector': wp.asset_path + "/plugins/leaflet/esri-leaflet-vector.js",
        }
        var defaults = {
            icon: Cm.o('map.icon'),
        };

        if( $maps && $maps.length ) {
            $maps.each( function() {
                Cm.map.loading($(this));
            });
            $.getScript( scripts.leaflet )
                .done(function( script, textStatus ) {
                    $.getScript( scripts.esri ).done( function(script, textStatus) {
                        $.getScript( scripts.mapbox ).done( function(script, textStatus) {
                            $.getScript( scripts.vector ).done( function(script, textStatus) {
                                $maps.each( function() {
                                    var data = this.dataset;
                                    var lat = data.lat;
                                    var lng = data.lng;

                                    var featureGroup;
                                    var map = L.map(this.id, {
                                        zoomControl: false
                                    }).setView([lat, lng], 15);

                                    if (data.hasOwnProperty('noScroll')) {
                                        map.scrollWheelZoom.disable();
                                    }

                                    L.control.zoom({
                                        position: 'bottomright'
                                    }).addTo(map);

                                    var layer = L.esri.Vector.basemap('Newspaper').addTo(map);
                                    var iconMain = L.icon({
                                        iconUrl: defaults.icon,
                                        iconSize: [38,64],
                                        className: 'map-icon-pin--main',
                                        popupAnchor: [0, -30]
                                    });

                                    L.marker([lat, lng], { icon: iconMain }).addTo(map);
                                    //.bindPopup('<h5>'+data.text+'</h5>').openPopup();
                                });
                            });
                        });
                    });
                });
        }
    }
};